<div class="grid">
  <div class="col-12 md:ml-5 py-4">
    <div class="flex-auto flex-wrap justify-content-center">
      <form [formGroup]="orderConfirmForm" (ngSubmit)="onSubmit()">
        <h4>{{ 'Order_Confirm.Order_Summary' | translate }}</h4>
        <div class="w-full h-2rem"></div>
        <p-divider styleClass="m-0" />
        <div class="w-full h-2rem"></div>
        <h5>{{ getOrderItemAttribute('name') }}</h5>
        <div class="w-full h-1rem"></div>
        <div class="w-full h-2rem"></div>
        <h5>
          {{ 'Order_Confirm.Patient' | translate }}
          {{ orderData?.patientFirstName + ' ' + orderData?.patientLastName }}
        </h5>
        <div class="w-full h-1rem"></div>
        <div class="w-full">
          <span class="label">{{ orderData?.patientDateOfBirth | date: dateFormat }}</span>
        </div>
        <div class="w-full h-2rem"></div>
        <div class="flex w-full">
          <div class="flex col-1 flex-column w-2rem">
            <p-checkbox [binary]="true" formControlName="patientConsent" inputId="checkbox" />
          </div>
          <div class="col-11 patient-consent" [innerHTML]="'Order_Confirm.Patient_Consent' | translate"></div>
        </div>
        <div class="col-12">
          @if (
              orderConfirmForm.controls.patientConsent.touched &&
              orderConfirmForm.controls.patientConsent.hasError('required')
            ) {
<small
            class="text-danger"
           >
            {{ 'Order_Confirm.DisclaimerIsRequired' | translate }}
          </small>
}
        </div>
      </form>
    </div>
  </div>
</div>
